import ReactJson from "react-json-view";
import { FaRegDotCircle } from "react-icons/fa";

export default function ModalComponent({ data }) {
    return (
        <div className="container-fluid font-monospace">
            {/* <div className="h3 mb-3">Detail</div> */}
            <div className="row">
                <ModalDetail title="position_start" text={data?.position_start} />
                <ModalDetail title="position_stop" text={data?.position_stop} />
                <ModalDetail title="type" text={data?.type} />
                <ModalDetail title="irgsp_1_0" text={data?.irgsp_1_0} />

                <div className="col-12 mb-4">
                    <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                        <div className="mx-2">
                            <FaRegDotCircle className="text-primary" />
                        </div>
                        <div>data_id</div>
                    </div>
                    <div style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word" }}>
                        <ReactJson src={data?.data_id} name={null} displayObjectSize={false} displayDataTypes={false} />
                    </div>
                </div>
            </div>
        </div>
    );
}

function ModalDetail({ title, text }) {
    return (
        <div className="col-12 col-md-6 col-xl-4 col-xxl-3 mb-4">
            <div className="fw-bold mb-2 d-flex align-items-center" style={{ fontSize: 18 }}>
                <div className="mx-2">
                    <FaRegDotCircle className="text-primary" />
                </div>
                <div>{title}</div>
            </div>
            <div className="bg-light p-1 rounded" style={{ marginLeft: 35, maxWidth: "100%", wordWrap: "break-word", fontFamily: "monospace" }}>
                {text}
            </div>
        </div>
    );
}
